// import up from '../../assets/9056894_arrow_up_r_icon.png'
// import './myTeam.css'
// import React, { useEffect, useState } from 'react'
// import { useContext } from 'react';
// import { AppContext } from '../../App';
// import { useNavigate } from 'react-router-dom';
// import { Link } from 'react-router-dom';
// import Side from '../side/Side';
// import { toast } from 'react-toastify';


// const MyTeam = () => {
//     const {route ,setLoader}=useContext(AppContext)
//     const [left,setLeft]=useState({})
//     const [right,setRight]=useState({})
//     const [mainName,setMainName]=useState("")
//     const [mainId,setMainId]=useState("")
//     const [showAdd,setShowAdd]=useState(true)
//     const [showUp,setShowUp]=useState(false)
//     const [userId,setUserId]=useState("")
//     const [parent,setParent]=useState("")
//     // const [lastName,setLastName]=useState("")
//     // const [lastId,setLastId]=useState("")

//     const reload =()=>{
//         window.location.reload();
      
//     }

//     const getUserTree =(name,id)=>{
//         // setLastId(mainId)
//         // setLastName(mainName)
//         setLoader(true)
//         setMainId(id)
//         setMainName(name)
//         setShowUp(true)
//         fetch(`${route}/acc/getMyTree/${id}`,{
//             headers:{
//                 "Authorization" :`Bearer ${sessionStorage.getItem("token")}`
//             }
//         })
//         .then(res=>res.json())
//         .then(data=>{
//             setLoader(false)
//             console.log(data)
//             setParent(data.data.parent)
//             if(data.data.leftChild){
//                 setLeft(data.data.leftChild)
                 
//             }
//             else{
//                 setLeft({})
//             }
//             if(data.data.rightChild){
//                 setRight(data.data.rightChild)
//             }
//             else{
//                 setRight({})
//             }
//         })
//     }
//     const getUserTreeByTop =()=>{
//         // setLastId(mainId)
//         // setLastName(mainName)
//         if(parent === sessionStorage.getItem("id")){
// setShowUp(false)

//         }
//         else{
//             setShowUp(true)
//         }
//         setLoader(true)
//         setMainId(parent)
       
//         fetch(`${route}/acc/getMyTree/${parent}`,{
//             headers:{
//                 "Authorization" :`Bearer ${sessionStorage.getItem("token")}`
//             }
//         })
//         .then(res=>res.json())
//         .then(data=>{
//             setLoader(false)
//             console.log(data)
//             setParent(data.data.parent)
//             setMainName(data.data.name)
//             if(data.data.leftChild){
//                 setLeft(data.data.leftChild)
                 
//             }
//             else{
//                 setLeft({})
//             }
//             if(data.data.rightChild){
//                 setRight(data.data.rightChild)
//             }
//             else{
//                 setRight({})
//             }
//         })
//     }
//     const getUserTreeBySearch =()=>{
//         setLoader(true)
      
//         fetch(`${route}/acc/getMyTree/${userId}`,{
//             headers:{
//                 "Authorization" :`Bearer ${sessionStorage.getItem("token")}`
//             }
//         })
//         .then(res=>res.json())
//         .then(data=>{
//             setLoader(false)
//             console.log(data)
//             if(data.status === "success"){
//                 setMainId(data.data.id)
//                 setMainName(data.data.name)
//                 setShowUp(true)
//             }
//             if(data.status === "failed"){
//              toast.error(data.message)
//             }
//             if(data.data.leftChild){
//                 setLeft(data.data.leftChild)
                 
//             }
//             else{
//                 setLeft({})
//             }
//             if(data.data.rightChild){
//                 setRight(data.data.rightChild)
//             }
//             else{
//                 setRight({})
//             }
//         })
//     }
//     useEffect(()=>{
//         setMainName(sessionStorage.getItem("userName"))
//         setMainId(sessionStorage.getItem("id"))
//         fetch(`${route}/acc/getMyTree/${sessionStorage.getItem("id")}`,{
//             headers:{
//                 "Authorization" :`Bearer ${sessionStorage.getItem("token")}`
//             }
//         })
//         .then(res=>res.json())
//         .then(data=>{
          
//             if(data.data.leftChild){
//                 setLeft(data.data.leftChild)
//             }
//             if(data.data.rightChild){
//                 setRight(data.data.rightChild)
//             }
//             if(data.data.leftChild && data.data.rightChild){
//                 setShowAdd(false)
//             }
//         })
//     },[])
//   return (
//   <div className="team">
   
//     <div className="container">
//     {showAdd ?     <Link to="/add-user">أضف عضو جديد</Link> : null}
//     {/* <Link to="/add-user">أضف عضو جديد</Link>  */}
//   {showUp ?   <img src={up} onClick={getUserTreeByTop} alt="" className="up" /> : null}
//   <label htmlFor="">
//     يمكنك البحث في المؤسسة من هنا
//     <input onChange={(e)=>setUserId(e.target.value)} type="text" placeholder='اكتب كود المكتب الخاص' />
//     <button onClick={getUserTreeBySearch}>بحث</button>
//   </label>
//        <div className="first">
//         <div className="top">
//             <div className="name">{mainName}</div>
//             <div className="id">{mainId}</div>
//         </div>
//         <div className="sec-left">
//             {left.name ?   <div className="in-left" onClick={()=>getUserTree(left.name , left.id)}>
//             <div>{left.name}</div>
//             <div>{left.id}</div>
//         </div> :   <div className="in-left empty">
//             <div>اٍضافة عضو جديد</div>
//             <div>+</div>
//         </div> }
      
//         <div className="l-left">
//             {left.left_child ? <div onClick={()=>getUserTree(left.left_child.name , left.left_child.id)} className='in-l-left' >
//             <div>{left.left_child.name}</div>
//             <div>{left.left_child.id}</div>
//             </div>:<div className='in-l-left empty'>
//             <div>اٍضافة عضو جديد</div>
//             <div>+</div>
//             </div> }
            
//         </div>
//         <div className="l-right">
//         {left.right_child ? <div onClick={()=>getUserTree(left.right_child.name , left.right_child.id)} className='in-l-right'>
//             <div>{left.right_child.name}</div>
//             <div>{left.right_child.id}</div>
//             </div>:<div className='in-l-right empty'>
//             <div>اٍضافة عضو جديد</div>
//             <div>+</div>
//             </div> }
//         </div>
//         </div>
//         <div className="sec-right">
//         {right.name ?   <div className="in-right" onClick={()=>getUserTree(right.name , right.id)}>
//             <div>{right.name}</div>
//             <div>{right.id}</div>
//         </div> :   <div className="in-right empty">
//             <div>اٍضافة عضو جديد</div>
//             <div>+</div>
//         </div> }
//             <div className="r-left">
//                 {right.left_child ? <div className='in-r-left' onClick={()=>getUserTree(right.left_child.name , right.left_child.id)}>
//                 <div>{right.left_child.name}</div>
//             <div>{right.left_child.id}</div>
//                 </div>:<div className='in-r-left empty'>
//                 <div>اٍضافة عضو جديد</div>
//             <div>+</div></div>}
          
//             </div>
//             <div className="r-right">
//             {right.right_child ? <div className='in-r-right' onClick={()=>getUserTree(right.right_child.name , right.right_child.id)}>
//                 <div>{right.right_child.name}</div>
//             <div>{right.right_child.id}</div>
//                 </div>:<div className='in-r-right empty'>
//                 <div>اٍضافة عضو جديد</div>
//             <div>+</div></div>}
//             </div>
//         </div>
//        </div>
//     </div>
//     <Side />
//   </div>
//   )
// }

// export default MyTeam
import "./myTeam.scss";
import React, { useEffect, useState, useContext } from "react";
import { AppContext } from "../../App";
import Side from "../side/Side";
import up from "../../assets/9056894_arrow_up_r_icon.png";
import { toast } from "react-toastify";
import {Link} from 'react-router-dom'

const Node = ({ user, onClick, emptyText }) => {
  if (!user?.name) {
    return (
      <div className="node empty">
        <Link to="/add-user">
        <span>{emptyText}</span>
        <span className="plus">+</span>
        </Link>
      </div>
    );
  }

  return (
    <div className="node" onClick={onClick}>
      <div className="node-name">{user.name}</div>
      <div className="node-id">{user.id}</div>
    </div>
  );
};

const MyTeam = () => {
  const { route, setLoader } = useContext(AppContext);

  const [left, setLeft] = useState({});
  const [right, setRight] = useState({});
  const [mainName, setMainName] = useState("");
  const [mainId, setMainId] = useState("");
  const [parent, setParent] = useState("");
  const [showUp, setShowUp] = useState(false);
  const [userId, setUserId] = useState("");
const [showAdd, setShowAdd] = useState(true)

  const getUserTree = (name, id) => {
    setLoader(true);
    setMainName(name);
    setMainId(id);
    setShowUp(true);

    fetch(`${route}/acc/getMyTree/${id}`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setLoader(false);
        setParent(data.data.parent);
        setLeft(data.data.leftChild || {});
        setRight(data.data.rightChild || {});
        if (data.data.leftChild && data.data.rightChild) {
    setShowAdd(false)
  } else {
    setShowAdd(true)
  }
      });

  };

  const getUserTreeByTop = () => {
    if (!parent) return;

    setLoader(true);

    fetch(`${route}/acc/getMyTree/${parent}`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setLoader(false);
        setMainName(data.data.name);
        setMainId(data.data.id);
        setParent(data.data.parent);
        setLeft(data.data.leftChild || {});
        setRight(data.data.rightChild || {});

        if (data.data.leftChild && data.data.rightChild) {
  setShowAdd(false)
} else {
  setShowAdd(true)
}

      });
  };

  const searchUser = () => {
    if (!userId) return;

    setLoader(true);
    fetch(`${route}/acc/getMyTree/${userId}`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setLoader(false);
        if (data.status === "failed") {
          toast.error(data.message);
          return;
        }
        setMainName(data.data.name);
        setMainId(data.data.id);
        setParent(data.data.parent);
        setLeft(data.data.leftChild || {});
        setRight(data.data.rightChild || {});
        setShowUp(true);

        if (data.data.leftChild && data.data.rightChild) {
  setShowAdd(false)
} else {
  setShowAdd(true)
}

      });
  };

  useEffect(() => {
    const id = sessionStorage.getItem("id");
    const name = sessionStorage.getItem("userName");

    setMainId(id);
    setMainName(name);

    fetch(`${route}/acc/getMyTree/${id}`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setLeft(data.data.leftChild || {});
        setRight(data.data.rightChild || {});
        if (data.data.leftChild && data.data.rightChild) {
  setShowAdd(false)
} else {
  setShowAdd(true)
}

      });
  }, []);

  return (
    <div className="team-page">
        {/* Add Member Button */}
{showAdd && (
  <Link
    
   to="/add-user"
  >
    <button className="add-member-btn">

    + إضافة عضو جديد
    </button>
  </Link>
)}

      <div className="team-container">
        {showUp && (
          <img src={up} alt="up" className="up-btn" onClick={getUserTreeByTop} />
        )}

        <div className="search-box">
          <input
            type="text"
            placeholder="اكتب كود المكتب"
            onChange={(e) => setUserId(e.target.value)}
          />
          <button onClick={searchUser}>بحث</button>
        </div>

        <div className="tree">
          {/* ROOT */}
          <Node user={{ name: mainName, id: mainId }} />

          {/* LEVEL 1 */}
          <div className="level">
            <Node
              user={left}
              emptyText="إضافة عضو"
              onClick={() => getUserTree(left.name, left.id)}
            />
            <Node
              user={right}
              emptyText="إضافة عضو"
              onClick={() => getUserTree(right.name, right.id)}
            />
          </div>

          {/* LEVEL 2 */}
          <div className="level">
            <Node
              user={left.left_child}
              emptyText="إضافة عضو"
              onClick={() =>
                getUserTree(left.left_child?.name, left.left_child?.id)
              }
            />
            <Node
              user={left.right_child}
              emptyText="إضافة عضو"
              onClick={() =>
                getUserTree(left.right_child?.name, left.right_child?.id)
              }
            />
            <Node
              user={right.left_child}
              emptyText="إضافة عضو"
              onClick={() =>
                getUserTree(right.left_child?.name, right.left_child?.id)
              }
            />
            <Node
              user={right.right_child}
              emptyText="إضافة عضو"
              onClick={() =>
                getUserTree(right.right_child?.name, right.right_child?.id)
              }
            />
          </div>
        </div>
      </div>

      <Side />
    </div>
  );
};

export default MyTeam;
